import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  LabReqAB,
  LabReqQC,
  LabReqBC,
  LabReqON
} from './lab-req-base.component';
import { InputGroupComponent } from '../components/input-group/input-group.component';
import { AngularAntdModule } from '../../../angular-antd.module';
import { LabReqElementComponent } from '../components/lab-req-element/lab-req-element.component';
import { InputElementComponent } from '../components/input-element/input-element.component';
import { CustomCheckboxComponent } from '../components/custom-checkbox/custom-checkbox.component';

@NgModule({
  declarations: [
    LabReqQC,
    LabReqON,
    LabReqAB,
    LabReqBC,
    InputGroupComponent,
    InputElementComponent,
    LabReqElementComponent,
    CustomCheckboxComponent
  ],
  providers: [],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AngularAntdModule],
  exports: [
    LabReqAB,
    LabReqQC,
    LabReqON,
    LabReqBC,
    FormsModule,
    ReactiveFormsModule,
    AngularAntdModule
  ]
})
export class LabReqBaseModule {}
